<template>
  <div>
    <!-- QUOTE EXPIRED MODAL  -->
    <modal-alert
      v-if="modalAlert === 'quoteExpired' && !isRequoteModalEnabled"
      @success="$emit('go-to-form', 3)"
      @cancel="$emit('cancel')"
    >
      <template #title>
        This quote has expired
      </template>
      <template #sub-header>
        The insurance start date has passed.
      </template>
      <template #message>
        However, you can re-run this quote using the same
        details and update any necessary information to get a new quote
      </template>
      <template #cancelText>No, view expired quote</template>
      <template #confirmText>Yes, re-run quote</template>
    </modal-alert>
    <!-- REQUTE MODAL  -->
    <modal-requote-expired
      v-if="isRequoteModalEnabled"
      @go-to-form="$emit('go-to-form')"
      @new-start-date-requote="$emit('new-start-date-requote', $event)"
    />
    <modal-alert
      v-if="modalAlert === 'expiredQuestions'"
      :cancel="false"
      @success="$emit('go-to-form')"
    >
      <template #title>
        This quote has expired
      </template>
      <template #message>
        <p>
          We have recently made some changes to our questions,
          to ensure your quotes are accurate we need you to review the
          information again.
        </p>
        <p>This should only take a minute.</p>
      </template>
      <template #confirmText>Proceed</template>
    </modal-alert>
    <modal-alert
      v-if="modalAlert === 'noResults'"
      @success="$emit('go-to-form', 1)"
      @cancel="$emit('cancel')"
    >
      <template #title>
        No quotes available online
      </template>
      <template #message>
        Unfortunately, none of our panel members were able to quote online this time.
        We would recommend clicking 'Edit quote' if you would like to review your quote information again.
      </template>
      <template #cancelText>Close</template>
      <template #confirmText>Edit quote</template>
    </modal-alert>
    <modal-alert
      v-if="modalAlert === 'exceedQuotes'"
      :cancel="false"
      @success="$emit('go-to-form', 3)"
    >
      <template #title>
        Quote limit exceeded
      </template>
      <template #message>
        <div v-html="config.partnerQuoteLimitData" />
      </template>
      <template #confirmText>OK</template>
    </modal-alert>
    <modal-alert
      v-if="modalAlert === 'brokerModal'"
      :cancel="true"
      @success="$emit('success')"
      @cancel="$emit('cancel')"
    >
      <template #title>
        Not found a quote you like?
      </template>
      <template #sub-header>
        <broker-solution-more-quotes-text />
      </template>
      <template #confirmText>
        Get More Quotes
      </template>
      <template #cancelText>
        No, thank you!
      </template>
    </modal-alert>
  </div>
</template>

<script>
import {
  inject,
  computed,
} from '@vue/composition-api';
import ModalAlert from '@/components/car/Results/ModalAlert.vue';
import ModalRequoteExpired from '@/components/car/Results/ModalRequoteExpired';
import BrokerSolutionMoreQuotesText from '@/components/shared/BrokerSolutionMoreQuotesText.vue';

export default {
  name: 'results-modal-alerts',
  components: {
    ModalAlert,
    ModalRequoteExpired,
    BrokerSolutionMoreQuotesText,
  },
  inject: ['config'],
  props: {
    modalAlert: {
      type: [String, Boolean],
      required: true,
    },
  },
  setup (props, { root }) {
    // INJECTS
    const {
      isInsuranceStartDateElapsed,
    } = inject('abTastyControllerUI');
    const config = inject('config');
    const helpers = inject('helpers');

    // COMPUTED
    const isSidFromEmail = computed(() => root.$route.query?.utm_medium === 'email');
    const isRequoteModalEnabled = computed(() => props.modalAlert === 'quoteExpired' && isSidFromEmail.value && isInsuranceStartDateElapsed.value && helpers.isQuotezonePartner(config.partner));

    return {
      isRequoteModalEnabled,
    };
  },
};
</script>
